export const gameDefaultTranslations = {
  ABOUT_THE_GAME: 'Introduction',
  ABOUT_THE_GAME_P1:
    'Golden Tree is a 5x3 slot game. The winning combinations are reached when the same symbols appear on matrix consecutively from left to right except for the scatter symbols. The Dollar falls anywhere on the matrix and the Star falls on 1st, 3rd and 5th reels. ',
  AMBIENCE_SOUND: 'Ambience Sound',
  AUTO_PLAY: 'Auto Play ',
  AUTO_SPIN_P1: 'AUTO PLAY triggers continuous gameplay with no need to press any buttons.',
  AUTO_SPIN_P2: 'The Player should select Auto Play quantity and reels will start automatically.',
  AUTO_SPIN_P3: 'To stop Auto Play, you simply press the Stop button.',
  AUTO_SPIN_P4: 'Auto Play is stopped automatically when you leave the game or face malfunctions.',
  BALANCE: 'Balance',
  BET_NOT_ACCEPTED: 'Your bet is not accepted. Please try again.',
  BIG_WIN: 'Big Win',
  BONUS_ROUND_POPUP: 'You have completed your Free Spins',
  CONGRATULATIONS_3: 'Congratulations! You have {{VALUE}} Free Spins.',
  CONGRATULATIONS_4: 'Congratulations!',
  CONNECTIVITY_AND_MALFUNCTION: 'Connectivity and malfunction',
  CONNECTIVITY_MALFUNCTION: 'Connectivity and malfunction',
  EPIC_WIN: 'Epic Win',
  EXPIRY: 'Expires in',
  FREE_SPINS_BONUS: 'You have {{VALUE}} Free Spins.',
  FREE_SPINS_LEFT: 'Free Spins Left {{VALUE}}',
  GAMBLE_AMOUNT_TEXT: 'Gamble Amount',
  GAMBLE_ATTEMPTS_FINISHED_TEXT: 'Gamble Attempts Finished',
  GAMBLE_ATTEMPTS_LEFT_TEXT: 'Gamble Attempts Left',
  GAMBLE_FEATURE: 'Gamble Feature',
  GAMBLE_FEATURE_TEXT:
    "The Player is given the option to Gamble the win by pressing the x2 button. The Player can gamble the win equal to or less than x35. The number of Gamble attempts is pre-defined. The maximum number of attempts may vary between 1 and 8. There are two buttons to select: Red and Black. When selecting Black or Red, the card flips and shows the Player's result. If the player has guessed the color of the card, the win doubles and the Player continues his gamble attempts. This process continues until the Player guesses incorrectly or finishes his gamble attempts. The past cards are kept in the History section.",
  GAMBLE_FEATURE_TITLE: 'Gamble Feature',
  GAMBLE_FEATURE_VALIDATIONS_TEXT:
    'If the Player has entered the gamble scene but did not do any gamble, and there is a connection issue or the game is reloaded, the win is automatically collected. If the Player has entered the gamble scene and used one of his gamble opportunities, and there is a connection issue or he reloads the game, the win is automatically collected.',
  GAMBLE_TO_WIN_TEXT: 'Gamble to Win',
  GAMBLE_VALIDATIONS: 'Gamble Validations:',
  GAME_HISTORY: 'Game History',
  GAME_INFO_HOW_TO_PLAY: 'How to Play',
  GAME_NAME: 'GOLDEN TREE',
  GAME_RULES: 'Game Rules',
  GAME_RULES_1: 'Game Rules',
  GAME_RULES_GAME_FEATURES: 'Game Features',
  GENERAL_INFORMATION: 'Quick Info',
  HOME: 'Home',
  HOW_TO_PLAY_P1:
    'To start playing, select the bet amount. The reels will spin and eventually start at random.',
  HOW_TO_PLAY_P2:
    'You win if the same symbols appear on matrix consecutively from left to right except for scatters. Available winning lines will be highlighted and your winning will be credited to your account balance.',
  INSUFFICIENT_FUNDS: 'Insufficient amount. Please refill your balance.',
  INTRODUCTION:
    'The Tree of Life will lead you through the game and enrich your gaming experience.',
  INVALID_TOKEN: 'Your session is over. Please reload the game.',
  JACKPOT: 'Jackpot',
  JACKPOT_INTRO:
    'Three Jackpot symbols award a Jackpot Win. A four level progressive Jackpot increases the chances of marvelous wins.',
  JACKPOT_P1: 'A four-level progressive Jackpot increases the chances of marvelous wins.',
  JACKPOT_P2: 'Each level is illustrated by a game suit. ',
  JACKPOT_P3: 'CLUBS - 1st level (the lowest value)',
  JACKPOT_P4: 'DIAMONDS - 2nd level',
  JACKPOT_P5: 'HEARTS - 3rd level',
  JACKPOT_P6: 'SPADES - 4th level (the highest level)',
  JACKPOT_P7: 'Jackpot Contribution',
  JACKPOT_P8: 'There is no minimum bet amount to qualify for Jackpot.',
  JACKPOT_P9:
    "The jackpot contribution is 1% from the Player's bet amount that is distributed evenly among the four Jackpot levels from the Provider's side.",
  JACKPOT_P10: "No amount is deducted from the Player's bet.",
  JACKPOT_P11: 'The Players can win the Jackpot only by playing with real money.',
  JACKPOT_P12: 'The Player cannot win a Jackpot during Free Spins or playing a Bonus Game.',
  JACKPOT_P13: 'Jackpot Game',
  JACKPOT_P14:
    'The Player gets three Jackpot symbols in the main game and enters into a Jackpot game.',
  JACKPOT_P15:
    'The Player is offered to open Pascal Gaming Symbols. The Player wins a Jackpot as soon as he opens three of the same card suits: Clubs, Diamonds, Hearts or Spades.',
  JACKPOT_P16:
    'The Player has five minutes to open the cards suits and have a marvelous Jackpot win. The Timer is placed on top of the scene. ',
  JACKPOT_P17:
    'The Jackpot is visible during the game and it is updated in real-time, offering complete transparency to Players.',
  JACKPOT_P18: 'Jackpot game validations:',
  JACKPOT_P19:
    "The Player should open three of the same card suits within 5 minutes, otherwise, the game will open the card suits for the Player randomly and add the Jackpot win to the Player's balance.",
  JACKPOT_P20: 'In case of connection loss or issue, the win is added to the Player’s balance.',
  JACKPOT_P21: 'Rules and Malfunctions',
  JACKPOT_P22: 'Jackpot is reset after a win.',
  JACKPOT_P23: 'Auto Bet is automatically stopped when Jackpot is won.',
  JACKPOT_P24: 'Slow Internet connection could cause a delay in showing real-time Jackpot values.',
  JACKPOT_P25: 'A Jackpot supports recovery in case of disconnection.',
  JACKPOT_SERVICE_UNAVAILABLE: 'We have a technical issue, the game will be available soon.',
  LARGEST_WINNER: 'Largest Winner',
  LAST_WIN: 'Last Win',
  LAST_WINNER: 'Last Winner',
  LOST_CONNECTION: 'Your connection is lost. Please refresh the page.',
  MAINTENANCE: 'Your session will be interrupted in {{VALUE}} seconds for maintenance purposes.',
  MALFUNCTION: 'Malfunction voids all pays and plays',
  MAX_WIN:
    'The maximum win is limited to {{VALUE}}x bet. If the maximum win of the round reaches {{VALUE}}x bet, the round immediately ends and the win is awarded up to the cap and all the remaining features are discontinued.',
  MEGA_WIN: 'Mega Win',
  NUMBER_OF_WINNERS: 'Number of Winners',
  OK: 'Ok',
  PAYTABLE: 'Pay Table',
  PLAY: 'Play',
  QUICK_BETS: 'Quick Bets',
  QUICK_INFO_MATRIX_SIZE: 'Matrix size: 5x3',
  QUICK_INFO_MAX_BET: 'Maximum Bet {{VALUE}}',
  QUICK_INFO_MAX_ODD: 'Maximum Odd {{VALUE}}x',
  QUICK_INFO_MIN_BET: 'Minimum Bet {{VALUE}}',
  QUICK_INFO_PAY_LINE: 'Pay line: 10',
  QUICK_INFO_RTP: 'The game theoretical RTP is 96,38%.',
  QUICK_INFO_VOLATILITY: 'Volatility is Medium',
  RECONNECTING: 'Reconnecting…',
  REFRESH: 'Refresh',
  SESSION_INACTIVITY: 'Your session was interrupted due to inactivity in the game.',
  SETTINGS: 'Settings',
  SOUNDS_EFFECTS: 'Sound Effects',
  SUPER_WIN: 'Super Win',
  SYMBOL_PAYOUT: 'Symbol Payout',
  SYMBOL_PAYOUT_1:
    'An Expanding Wild lands on 2nd, 3rd and 4th reels and substitutes for all symbols on the same reel except for a Dollar and a Star.',
  SYMBOL_PAYOUT_2: ' The Star falls anywhere on the 1st, 3rd and 5th reels. ',
  SYMBOL_PAYOUT_3: 'The Dollar falls anywhere on the matrix. ',
  SYMBOL_PAYOUT_TEXT: 'Game symbols and odds are presented above.',
  TECHNICAL_ISSUES: 'Oops… Something went wrong. Please try again.',
  TOTAL_WIN: 'Total WIn',
  TURBO_MODE: 'Fast and Turbo Modes',
  TURBO_MODE_P1:
    'By activating the Fast mode, the reels start spinning faster, and by activating Turbo mode, the reels reach the fastest speed mode. ',
  TWO_DEVICE_ENTRANCE:
    'Your session was interrupted due to inactivity or login from another device.',
  WILD: 'Wild',
  WILDS: 'Wild',
  WILDS_TEXT:
    'An expanding Wild substitutes all paying symbols on the same reel except for scatter symbols.',
  WILD_RULES_P1:
    'An Expanding Wild lands on 2nd, 3rd and 4th reels and substitutes for all symbols on the same reel except for a Dollar and a Star.',
  WIN: 'Win',
  WINNING_LINES: 'Winning Lines',
  WINNING_LINES_TEXT:
    'Winning combinations are reached when the same symbols appear on matrix consecutively from left to right except for scatter symbols.',
};
